import { forwardRef, type HTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

/**
 * Текстовые стили Hint/Muted (`.hint`/`.muted` макета). Это стили, а не отдельные единицы
 * инвентаря — представлены на справочной странице типографики (capability component-catalog).
 */

/** Подсказочный текст: 12px, третичный цвет. */
export const Hint = forwardRef<HTMLParagraphElement, HTMLAttributes<HTMLParagraphElement>>(
  ({ className, ...props }, ref) => (
    <p ref={ref} className={cn('text-12 text-txt-tertiary', className)} {...props} />
  ),
)
Hint.displayName = 'Hint'

/** Приглушённый текст: вторичный цвет. */
export const Muted = forwardRef<HTMLSpanElement, HTMLAttributes<HTMLSpanElement>>(
  ({ className, ...props }, ref) => (
    <span ref={ref} className={cn('text-txt-secondary', className)} {...props} />
  ),
)
Muted.displayName = 'Muted'
